<template>

    <div>

      <div ref="btnRef" v-on:mouseenter="toggleTooltip()" v-on:mouseleave="toggleTooltip()" >
        <slot name="button" > 
            Default button
        </slot>
      </div>
      
      <div ref="tooltipRef" v-bind:class="{'hidden': !tooltipShow, 'block': tooltipShow}" class="bg-black border-0 mt-3 block z-50 font-normal leading-normal text-sm max-w-xs text-left no-underline break-words rounded-lg">
        <div>
            <slot name="text">
    
          <div class="text-white p-3">
            And here's some amazing content. It's very engaging. Right?
          </div>
          </slot>
        </div>
      </div>
    </div>

</template>

<script>

import Popper from "popper.js";

export default {
  name: "bottom-pink-tooltip",
  data() {
    return {
      tooltipShow: false
    }
  },
  methods: {
    toggleTooltip: function(){
      if(this.tooltipShow){
        this.tooltipShow = false;
      } else {
        this.tooltipShow = true;
        new Popper(this.$refs.btnRef, this.$refs.tooltipRef, {
          placement: "bottom"
        });
      }
    }
  }
}
</script>